import { startSandboxListeners } from '../modules/ApiSettings/listeners';
import { startCreateTrListeners } from '../modules/GeneralFlow/listeners/createTr';
import { startDraftQuoteListeners } from '../modules/GeneralFlow/listeners/draftQuote';
import { startNavigationListeners } from '../modules/GeneralFlow/listeners/navigation';
import { startPricingListeners } from '../modules/GeneralFlow/listeners/pricing';
import { startTrackingListeners } from '../modules/GeneralFlow/listeners/tracking';
import { startWidgetParamsListeners } from '../modules/GeneralFlow/listeners/widgetParams';
import { startUserListeners } from '../modules/User/listeners';
import { startBaseListeners } from './baseListeners';

/**
 * Registers every listener on the listener middleware; called once, when the store is created.
 */
export const startListeners = (): void => {
  startBaseListeners();
  startSandboxListeners();
  startUserListeners();
  startNavigationListeners();
  startPricingListeners();
  startWidgetParamsListeners();
  startTrackingListeners();
  startDraftQuoteListeners();
  startCreateTrListeners();
};
